/* eslint-disable jsx-a11y/anchor-is-valid */
import { Button } from "shared/Components/button";

export const ResultCard = ({ call_name, registration_name,breed,owner_name, onViewResult }) => {
    console.log(registration_name)
    return (
        <div class="bg-white p-4">
            <div class="flex justify-between items-center">
                <h2 class="text-lg font-semibold text-gray-900 w-7/12">Dog Name: {registration_name ? registration_name : call_name}</h2>
            </div>
            <p class="text-gray-600 text-sm mb-4">Breed: {breed}</p>
            <div class="flex justify-end items-center">
                <Button label="View More" width="w-32" onClick={onViewResult} />
            </div>
        </div>
    );
}